module.exports = __webpack_public_path__ + "img/logo.d42a5aa1.svg";